import { render } from "./eduResearchMenu.vue?vue&type=template&id=5a9b10b7&scoped=true"
import script from "./eduResearchMenu.vue?vue&type=script&lang=js"
export * from "./eduResearchMenu.vue?vue&type=script&lang=js"

import "./eduResearchMenu.vue?vue&type=style&index=0&id=5a9b10b7&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a9b10b7"]])

export default __exports__